import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { loadAuthConfig } from './services/authConfig'
import App from './App'
import './styles/main.css'

async function init() {
  const result = await loadAuthConfig()

  // Firebase-backed auth is active only on a resolved tenant host.
  const active = result.status === 'ok' && result.config.tenant !== null

  createRoot(document.getElementById('app')!).render(
    <StrictMode>
      <BrowserRouter>
        <AuthProvider active={active}>
          <App result={result} />
        </AuthProvider>
      </BrowserRouter>
    </StrictMode>
  )
}

init()
